import { BeneficiarySubmissionProvider } from '@/components/blocks/BeneficiarySubmissionContext';
import { BeneficiarySubmissionModal } from '@/components/blocks/BeneficiarySubmissionModal';
import { useMobileHeaderQuery } from '@/components/content/Header';
import { HeaderMiniCartDesktopV2 } from '@/components/content/Header/parts/HeaderMiniCartDesktopV2';
import { HeaderMiniCartMobile } from '@/components/content/Header/parts/HeaderMiniCartMobile';
import { useCart } from '@/data/Content/Cart';
import { useNotifications } from '@/data/Content/Notifications';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useUser } from '@/data/User';
import { Switch } from '@/utils/switch';
import { FC, MouseEventHandler, useCallback, useEffect, useRef, useState } from 'react';

export const HeaderMiniCart: FC = () => {
	const router = useNextRouter();
	const { message } = useNotifications();
	const { user: { userId } = {} } = useUser();
	const { mutateCart, orderItems, onDeleteCart } = useCart();
	const isMobile = useMobileHeaderQuery();
	const [open, setOpen] = useState(false);
	const initialized = useRef<boolean>(false);
	const [count, setCount] = useState<number>(0);

	const handleToolTip = useCallback(
		(action?: string) => () => {
			setOpen((open) =>
				Switch(action)
					.case('open', () => true)
					.case('close', () => false)
					.defaultTo(() => !open)
			);
		},
		[]
	);
	const onMouseEnter: MouseEventHandler<HTMLDivElement> = useCallback(() => {
		if (!isMobile) {
			handleToolTip('open')();
		}
	}, [handleToolTip, isMobile]);
	useEffect(() => {
		if (message.isAddToCart) {
			setOpen(true);
		}
	}, [message.isAddToCart, router.basePath, message]);
	useEffect(() => {
		if (!router.asPath) return;
		handleToolTip('close')();
	}, [handleToolTip, router.asPath]);

	useEffect(() => {
		if (initialized.current) {
			mutateCart();
		} else {
			initialized.current = true;
		}
	}, [mutateCart, userId]);

	// for CDN caching -- render this on client
	useEffect(() => {
		const itemCount = orderItems?.length ?? 0;
		setCount(() => itemCount);
	}, [orderItems]);

	return (
		<BeneficiarySubmissionProvider>
			{isMobile ? (
				<HeaderMiniCartMobile
					open={open}
					count={count}
					handleToolTip={handleToolTip}
					onMouseEnter={onMouseEnter}
					onDeleteCart={onDeleteCart}
				/>
			) : (
				<HeaderMiniCartDesktopV2
					open={open}
					count={count}
					handleToolTip={handleToolTip}
					onMouseEnter={onMouseEnter}
					onDeleteCart={onDeleteCart}
				/>
			)}
			<BeneficiarySubmissionModal />
		</BeneficiarySubmissionProvider>
	);
};
